import ListItem from '@material-ui/core/ListItem'
import React from 'react'
import ListItemMenu from '../../components/controls/ListItemMenu'
import ListElementStyle from '../../styles/ListElementStyle'

class ListElement extends React.Component {
  state = {
    isMouseEnter: false,
  }

  handleToggleIsMouseEnter = value => {
    this.setState({ isMouseEnter: value })
  }

  render() {
    return (
      <ListElementStyle>
        <ListItem
          className="listItem"
          onMouseEnter={() => this.handleToggleIsMouseEnter(true)}
          onMouseLeave={() => this.handleToggleIsMouseEnter(false)}
        >
          {this.props.children}
          {this.state.isMouseEnter && (
            <ListItemMenu options={this.props.options} />
          )}
        </ListItem>
      </ListElementStyle>
    )
  }
}

export default ListElement
